






import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  components: {

  }
})

export default class Button extends Vue {
  @Prop() url: string;
  @Prop() text: string;


  async onLinkClick(url) {
    await this.$store.dispatch('routerStore/openPage', {
      url: url.replace('internal:', ''),
      external: Boolean(url.match('internal:')),
    });
  }
}
